import { Box, Drawer, HStack, Icon, IconButton, Separator, Text, VStack } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';
import { useParams } from '@tanstack/react-router';
import { GoGraph } from 'react-icons/go';
import { RxCross2 } from 'react-icons/rx';

import { IndicatorsService } from '@/client';

import { IndicatorCharts } from './IndicatorCharts';

type IndicatorDrawerProps = {
  indicatorId?: string;
  isOpen: boolean;
  editDisabled?: boolean;
  setIsOpen: (state: boolean) => void;
  refetch?: () => void;
};

const IndicatorSummaryDrawer = ({ indicatorId, isOpen, setIsOpen }: IndicatorDrawerProps) => {
  const { slug } = useParams({ strict: false });

  const { data: indicatorData } = useQuery({
    queryKey: ['indicatorDetails', { slug, id: indicatorId }],
    queryFn: async () => {
      return IndicatorsService.readIndicator({
        id: indicatorId ?? '',
        companySlug: slug,
      });
    },
    enabled: !!indicatorId && isOpen,
  });

  return (
    <Drawer.Root open={isOpen} onOpenChange={(e) => setIsOpen(e.open)} size={{ md: 'lg', base: 'md' }} placement="end">
      <Drawer.Backdrop />
      <Drawer.Positioner>
        <Drawer.Content
          rounded="md"
          position="absolute"
          margin="{spacing.4}"
          h="calc(100% - {spacing.4} * 2)"
          right={0}
          top={0}
        >
          <Drawer.CloseTrigger asChild>
            <IconButton variant={'ghost'}>
              <RxCross2 />
            </IconButton>
          </Drawer.CloseTrigger>
          <Drawer.Header alignItems="center">
            <HStack gap={4}>
              <Icon size={'2xl'}>
                <GoGraph />
              </Icon>
              <VStack gap={0} alignItems={'start'}>
                <Text textStyle={'lg'} fontWeight={'bold'}>
                  Synthèse des résultats de l'indicateur
                </Text>
                <Text textStyle={'sm'} color={'gray.500'} fontStyle={'italic'}>
                  {indicatorData?.name}
                </Text>
              </VStack>
            </HStack>
          </Drawer.Header>
          <Separator />
          <Drawer.Body p={0}>
            {indicatorId && (
              <Box p={4} display={'flex'} flexDirection={'column'} gap={4}>
                <IndicatorCharts slug={slug} indicatorId={indicatorId} />
              </Box>
            )}
          </Drawer.Body>
        </Drawer.Content>
      </Drawer.Positioner>
    </Drawer.Root>
  );
};

export default IndicatorSummaryDrawer;
